export const ALL_USER_FREE_TRIAL = 'ALL_USER_FREE_TRIAL';
export const ALL_USER_FREE_TRIAL_ORIGINAL = 'A';
export const ALL_USER_FREE_TRIAL_VARIATION = 'B';
export const ALL_USER_FREE_TRIAL_VARIATION_NO_BANNER = 'C';
export const LIVE_GROUP_NAV_LINK = 'LIVE_GROUP_NAV_LINK';
export const LIVE_GROUP_NAV_LINK_ORIGINAL = 'A';
export const LIVE_GROUP_NAV_LINK_VARIATION = 'B';
export const UNIFIED_PAYWALL_ROW = 'UNIFIED_PAYWALL_ROW';
export const UNIFIED_PAYWALL_ROW_ORIGINAL = 'A';
export const UNIFIED_PAYWALL_ROW_VARIATION = 'B';
export const UNIFIED_PAYWALL_GERMANY = 'UNIFIED_PAYWALL_GERMANY';
export const UNIFIED_PAYWALL_GERMANY_ORIGINAL = 'A';
export const UNIFIED_PAYWALL_GERMANY_VARIATION = 'B';
export const UNIFIED_PAYWALL_V2 = 'UNIFIED_PAYWALL_V2';
export const UNIFIED_PAYWALL_V2_ORIGINAL = 'A';
export const UNIFIED_PAYWALL_V2_VARIATION = 'B';
export const COMMUNICATIONS_OPT_IN_TOGGLE = 'REGISTRATION_EMAIL_OPT_IN_TOGGLE';
export const COMMUNICATIONS_OPT_IN_TOGGLE_ORIGINAL = 'A';
export const COMMUNICATIONS_OPT_IN_TOGGLE_VARIATION = 'B';
const experiments = {
    [ALL_USER_FREE_TRIAL]: {
        experimentId: '20932430038',
        variations: {
            20933463563: ALL_USER_FREE_TRIAL_ORIGINAL,
            20896748780: ALL_USER_FREE_TRIAL_VARIATION,
            21122110151: ALL_USER_FREE_TRIAL_VARIATION_NO_BANNER,
        },
    },
    [LIVE_GROUP_NAV_LINK]: {
        experimentId: '20610290278',
        variations: {
            20623550127: LIVE_GROUP_NAV_LINK_ORIGINAL,
            20630220107: LIVE_GROUP_NAV_LINK_VARIATION,
        },
    },
    [UNIFIED_PAYWALL_ROW]: {
        experimentId: '21113020319',
        variations: {
            21092430184: UNIFIED_PAYWALL_ROW_ORIGINAL,
            21103740003: UNIFIED_PAYWALL_ROW_VARIATION,
        },
    },
    [UNIFIED_PAYWALL_GERMANY]: {
        experimentId: '21086330870',
        variations: {
            21086371158: UNIFIED_PAYWALL_GERMANY_ORIGINAL,
            21088210881: UNIFIED_PAYWALL_GERMANY_VARIATION,
        },
    },
    [UNIFIED_PAYWALL_V2]: {
        experimentId: '21197381273',
        variations: {
            21185900910: UNIFIED_PAYWALL_V2_ORIGINAL,
            21205030840: UNIFIED_PAYWALL_V2_VARIATION,
        },
    },
    [COMMUNICATIONS_OPT_IN_TOGGLE]: {
        experimentId: '21145251001',
        variations: {
            21124302155: COMMUNICATIONS_OPT_IN_TOGGLE_ORIGINAL,
            21143531224: COMMUNICATIONS_OPT_IN_TOGGLE_VARIATION,
        },
    },
};
export default experiments;
